/**
 * Formats product hierarchy segments into a readable string
 */
export const formatProductHierarchy = (
  brand?: string,
  category?: string,
  product?: string
): string => {
  const segments = [];

  // Only add non-default values
  if (brand && brand.toLowerCase() !== "default") segments.push(brand);
  if (category && category.toLowerCase() !== "default") segments.push(category);
  if (product && product.toLowerCase() !== "default") segments.push(product);

  return segments.length > 0 ? segments.join(" | ") : "N/A";
};
